import { memo } from 'react';
import {
  SettingsIcons,
  SquigglyGridIcons,
  ThreeDIcons,
  UserSquareIcons,
} from '../../../../../../icons/icons';
import { ActionButton } from './ActionButton';
import { FilterButtonGroup } from './FilterButtonGroup';
import { GridViewControlsProps } from './interfaces';
import { Box, Divider } from '@mui/material';

export const GridViewControls = memo<GridViewControlsProps>(
  ({
    isAnalyticsFilterOpen,
    handleAnalyticsFilterOpen,
    handleGraphConfig,
    svgActiveTab,
    view3D,
    toggleSvgTab,
    loading,
    toggle3DViewWithReset,
    isAnalytical3D,
    showHeadshots,
    handleHeadshotToggle,
    handlePreQualFilterOpen,
    isPreQualFilterOpen,
    handleCCAFilterOpen,
    isCCAFilterOpen,
  }) => {
    return (
      <>
        <FilterButtonGroup
          onJDClick={handleAnalyticsFilterOpen}
          onPreQualClick={handlePreQualFilterOpen}
          onCCAClick={handleCCAFilterOpen}
          isJDActive={isAnalyticsFilterOpen}
          isPreQualActive={isPreQualFilterOpen}
          isCCAActive={isCCAFilterOpen}
        />

        <ActionButton
          onClick={handleGraphConfig}
          isActive={isAnalytical3D}
          icon={
            <Box sx={{ display: 'flex', transition: 'transform 0.2s' }}>
              <SquigglyGridIcons className="w-3.5 h-3.5" />
            </Box>
          }
          label="Graph"
          title="Configure graph settings"
        />

        <ActionButton
          onClick={toggleSvgTab}
          disabled={view3D}
          isActive={svgActiveTab === 3}
          icon={
            <Box sx={{ display: 'flex', transition: 'transform 0.2s' }}>
              <SettingsIcons className="w-3.5 h-3.5" />
            </Box>
          }
          label="Actions"
          title="Chart actions and tools"
        />

        <ActionButton
          onClick={handleHeadshotToggle}
          isActive={showHeadshots}
          variant="blue"
          icon={
            <Box sx={{ display: 'flex', transition: 'transform 0.2s' }}>
              <UserSquareIcons className="w-3.5 h-3.5" />
            </Box>
          }
          label="Headshot"
          title="Toggle between image avatars and text-based avatars"
        />

        <Divider
          orientation="vertical"
          flexItem
          sx={{ height: 20, alignSelf: 'center', mx: 0.25, bgcolor: 'rgba(203,213,225,0.6)' }}
        />

        <ActionButton
          onClick={toggle3DViewWithReset}
          disabled={loading}
          isActive={view3D}
          variant="purple"
          icon={
            <Box sx={{ display: 'flex', transition: 'transform 0.2s' }}>
              <ThreeDIcons className="w-3.5 h-3.5" />
            </Box>
          }
          label="3D"
          title="Toggle 3D visualization"
          hideOnSmall
        />
      </>
    );
  },
);

GridViewControls.displayName = 'GridViewControls';
